import {constants as kandyConstants} from 'kandy-redux'
import {handleActions} from 'redux-actions'
import {
    START_SESSION_FINISH,
    END_SESSION,
    SET_CUSTOMER_CONTEXT_FINISH,
    END_KANDY_CALL, MAKE_KANDY_CALL,
    CREATE_ESCALATED_SERVICE_REQUEST,
    UPDATE_ESCALATED_SERVICE_REQUEST,
    SET_UNREAD_COUNT,
    CHANGE_ACTIVE_CUSTOMER,
    CUSTOMER_DISCONNECTED,
    GET_RECENTCALL_FINISH,
    GET_CUSTOMERBYID_FINISH,
    GET_CUSTOMER_LIST,
    DELETE_CUSTOMER_INFO,
    GET_CUSTOMER_BY_ID,
    GET_CUSTOMER_REQUEST,
    ISSHOW_CALL_SHADE,
    CLEAR_HINT_MSG_FOR_CUSTOMER,
    RECEIVE_SESSION_TRANSFER_RESPONSE,
    CANCEL_SESSION_TRANSFER,
    SEND_RATE_FINISH,
    UPDATE_CUSTOMER_ID,
    END_SESSION_LOSSASS
} from '../constants/ActionTypes'
import {updateArrayItem} from '../utils/helpers'
import {EDIT_CURRENT_REQUEST_FINISH } from '../lossAss/constants/ActionTypes'
const initialState = {
    current: [],
    recent: [],
    recentCount: 0
}

const reducers = {}

/**
 * Top level reducers that only affect a single customer object.
 */
reducers[START_SESSION_FINISH] = {
    next(state, action) {
        if(!action.error){
	        return Object.assign({}, state, {
		        current: [...state.current, Object.assign({}, action.payload.serviceRequest, {
			        isSessionActive: true,
			        unreadCount: 0
		        })]
	        })
        }
        else{
	        return state
        }
    }
}


reducers[SET_CUSTOMER_CONTEXT_FINISH] = {
    next(state, action) {
        return Object.assign({}, state, {current: updateArrayItem(state.current, customer => customer.userId === action.payload.userId, {context: action.payload.context})})
    }
}

reducers[kandyConstants.MESSAGE_JSON_RECEIVED] = {
    next(state, action) {
        if (action.payload.message.message.json.type === 'providing-context') {
            return Object.assign({}, state, {current: updateArrayItem(state.current, customer => customer.userId === action.payload.message.sender.full_user_id, {context: action.payload.message.message.json.context})})
        } else {
            return state
        }
    }
}

reducers[MAKE_KANDY_CALL] = {
    next(state, action) {
        return Object.assign({}, state, {current: updateArrayItem(state.current, customer => customer.userId === action.payload.userId, {isInitiatingCallTo: true})})
    }
}
reducers[SEND_RATE_FINISH] = {
    next(state, action) {
        return Object.assign({}, state, {current: updateArrayItem(state.current, customer => customer._id === action.payload.customerId, {sendRated: true})})
    }
}


reducers[kandyConstants.CALL_INCOMING] = {
    next(state, action) {
        return Object.assign({}, state, {current: updateArrayItem(state.current, customer => customer.userId === action.payload.callerNumber, {callId: action.payload.callId})})
    }
}

reducers[END_KANDY_CALL] = {
    next(state, action) {
        return Object.assign({}, state, {current: updateArrayItem(state.current, customer => customer.userId === action.payload.userId, {callId: ''})})
    }
}


reducers[ISSHOW_CALL_SHADE] = {
    next(state, action){
        return Object.assign({}, state, {
            current: updateArrayItem(state.current, customer => customer.userId === action.payload.userId, {
                isShowShadeView: action.payload.isShowShade
            })
        })
    }
}

reducers[CUSTOMER_DISCONNECTED] = {
    next(state, action) {
        return Object.assign({}, state, {current: updateArrayItem(state.current, customer => customer.userId === action.payload.customerId, {connected: false})})
    }
}
/**
 * Handles ending a session with a specified user.
 * Removes the specified customer object from the list.
 */
reducers[END_SESSION] = {
    next(state, action) {

        var endedSession = state.current.filter(customer => customer.userId === action.payload.userId)[0]

        if (endedSession) {
            endedSession.isSessionActive = false
            endedSession.didSessionEnd = true

            return Object.assign({}, state, {
                recent: [...state.recent, endedSession],
                current: state.current.filter(customer => customer.userId !== action.payload.userId),
                isShowShadeView: false,
                currentStatus:'close'
            })
        } else {
            return state
        }
    }
}
reducers[END_SESSION_LOSSASS] = {
    next(state, action) {

        var endedSession = state.current.filter(customer => customer._id === action.payload.serviceRequestId)[0]

        if (endedSession) {
            endedSession.isSessionActive = false
            endedSession.didSessionEnd = true

            return Object.assign({}, state, {
                recent: [...state.recent, endedSession],
                current: state.current.filter(customer => customer._id !== action.payload.serviceRequestId),
                isShowShadeView: false,
                currentStatus:'close'
            })
        } else {
            return state
        }
    }
}

reducers[GET_RECENTCALL_FINISH] = {
    next(state = initialState, action) {
        let newstate = state.recent
        return Object.assign({}, state, {
            recent: action.payload.recentCall.result,
            recentCount: action.payload.recentCall.recentCount
        })
    }
}

reducers[CREATE_ESCALATED_SERVICE_REQUEST] = {
    next(state = initialState, action) {
        return Object.assign({}, state, {
            current: [Object.assign({}, action.payload.serviceRequest, {isSessionActive: false}), ...state.current]
        })
    }
}

reducers[UPDATE_ESCALATED_SERVICE_REQUEST] = {
    next(state = initialState, action) {
        return Object.assign({}, state, {
            current: updateArrayItem(state.current, customer => customer._id === action.payload.serviceRequest._id, Object.assign({}, action.payload.serviceRequest, {isSessionActive: true}))
        })
    }
}

reducers[SET_UNREAD_COUNT] = {
    next(state = initialState, action) {
        return Object.assign({}, state, {
            current: updateArrayItem(state.current, customer => customer._id === action.payload.requestId, {unreadCount: state.current.filter(customer => customer._id === action.payload.requestId)[0].unreadCount + 1})
        })
    }
}

reducers[CHANGE_ACTIVE_CUSTOMER] = {
    next(state = initialState, action) {
        // If another user was selected, change to them.
        if (action.payload.requestId) {
            return Object.assign({}, state, {
                current: updateArrayItem(state.current, customer => customer._id === action.payload.requestId, {unreadCount: 0})
            })
        } else {
            return state
        }

    }
}


reducers[CLEAR_HINT_MSG_FOR_CUSTOMER] = (state, action) => {
    return Object.assign({}, state, {
        updateSuccess: undefined,
        createSuccess: undefined,
        saveStart: undefined,
        errInfo: ''
    })
}


reducers[GET_CUSTOMERBYID_FINISH] = (state, action) => {
    return Object.assign({}, state, {getCustomerById: action.payload.findedData})
}


reducers[GET_CUSTOMER_LIST] = (state, action) => {

    return Object.assign({}, state, {
        customerList: action.payload.customerList, count: action.payload.count,pageSize:action.payload.pageSize,
        pageIndex:action.payload.pageIndex
    })

}


reducers[DELETE_CUSTOMER_INFO] = (state, action) => {

    if(action.error){
        return Object.assign({}, state, {deleteCustomerInfo: action.payload.response})
    }else {
        return Object.assign({}, state, {deleteCustomerInfo: action.payload.response})
    }

}

reducers[GET_CUSTOMER_BY_ID] = (state, action) => {
    return Object.assign({}, state, {customerInfoById: action.payload.response.result})
}
reducers[GET_CUSTOMER_REQUEST] = (state, action) => {

    return Object.assign({}, state, {customerRequest: action.payload.response.result})
}

reducers[CANCEL_SESSION_TRANSFER] = {
    next(state, action) {
        return Object.assign({}, state, {
            current: updateArrayItem(state.current, customer => customer.userId === action.payload.customerId, {
                transfer: {
                    status: 'cancel',
                    destAgentId: '',
                    comments: ''
                }
            })
        })
    }
}

reducers[RECEIVE_SESSION_TRANSFER_RESPONSE] = {
    next(state, action) {
        return Object.assign({}, state, {
            current: updateArrayItem(state.current, customer => {
                return customer.transfer && customer._id === action.payload.serviceRequestId
            }, {
                transfer: {
                    status: action.payload.status
                }
            })
        })
    }
}


reducers[UPDATE_CUSTOMER_ID] =(state,action) =>{

    return Object.assign({}, state, {
        current: updateArrayItem(state.current, customer => customer._id === action.payload.requestUserInfo._id, {
           userInfo:action.payload.requestUserInfo.userInfo
        })
    })
}

reducers[EDIT_CURRENT_REQUEST_FINISH] = (state,action)=>{
    if(!action.error){
        return Object.assign({},state,{
            current: updateArrayItem(state.current, customer => customer._id === action.payload.id, {
                userInfo:action.payload.userInfo
            })
        })
    }else {
        return state
    }
}



export default handleActions(reducers, initialState)
